const features = [
  {
    icon: 'ri-verified-badge-line',
    title: 'Verified Listings',
    desc: 'Every property on MyAbode is thoroughly verified by our team of experts to ensure accuracy and authenticity.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Easy Booking',
    desc: 'Schedule property viewings in seconds with our intuitive booking system. Pick your date, time, and preferred contact method.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Expert Agents',
    desc: 'Our network of 500+ certified agents are ready to guide you through every step of your property journey.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Secure & Trusted',
    desc: 'Your data and transactions are protected with bank-level security. We\'ve helped 50,000+ clients find their perfect home.',
  },
];

const WhyUsSection = () => (
  <section className="py-20 bg-amber-50">
    <div className="max-w-7xl mx-auto px-4 md:px-8">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        {/* Left */}
        <div>
          <p className="text-amber-500 text-xs font-semibold uppercase tracking-widest mb-3">Why Choose Us</p>
          <h2 className="text-4xl md:text-5xl font-black text-stone-900 leading-tight mb-5">
            The Smarter Way<br />to Find Home
          </h2>
          <p className="text-stone-500 text-base leading-relaxed mb-8">
            MyAbode combines cutting-edge technology with deep local expertise to deliver a property search experience unlike any other. We make finding your dream home simple, transparent, and enjoyable.
          </p>
          <div className="flex flex-wrap gap-4">
            <div className="flex items-center gap-2 text-stone-700 text-sm font-medium">
              <span className="w-5 h-5 flex items-center justify-center text-amber-500"><i className="ri-check-line font-bold"></i></span>
              No hidden fees
            </div>
            <div className="flex items-center gap-2 text-stone-700 text-sm font-medium">
              <span className="w-5 h-5 flex items-center justify-center text-amber-500"><i className="ri-check-line font-bold"></i></span>
              24/7 support
            </div>
            <div className="flex items-center gap-2 text-stone-700 text-sm font-medium">
              <span className="w-5 h-5 flex items-center justify-center text-amber-500"><i className="ri-check-line font-bold"></i></span>
              Instant notifications
            </div>
          </div>
        </div>

        {/* Right */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {features.map(f => (
            <div key={f.title} className="bg-white rounded-2xl p-6 border border-stone-100">
              <div className="w-11 h-11 flex items-center justify-center bg-amber-50 rounded-xl mb-4">
                <i className={`${f.icon} text-amber-500 text-xl`}></i>
              </div>
              <h3 className="font-bold text-stone-800 mb-2 text-sm">{f.title}</h3>
              <p className="text-stone-500 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default WhyUsSection;
